export const getCoordinates = (e, scale: number) => ({
  x: e.offsetX / scale,
  y: e.offsetY / scale,
  movementX: e.movementX / scale,
  movementY: e.movementY / scale,
});
